<script setup>
// composables
import useExtensionsLimit from "./api/useExtensionsLimit";

const {isUnlimited} = useExtensionsLimit()

defineProps({
    item: {
        type: Object,
        required: true
    }
})
</script>

<template>
    <!-- units mirror the API's "407 h 41 min" format -->
    <span v-if="isUnlimited(item)" class="tariff-time">
        <BIconInfinity class="tariff-time__infinity"/>&nbsp;h <BIconInfinity class="tariff-time__infinity"/>&nbsp;min
    </span>
    <template v-else>{{ item.tariff_time ?? '-' }}</template>
</template>

<style scoped lang="scss">
.tariff-time {
    white-space: nowrap;

    &__infinity {
        display: inline-block;
        font-size: 1.1em;
        vertical-align: -0.15em;
    }
}
</style>
